module.exports = __webpack_public_path__ + "static/media/minus-circle-white.dcfebc69.svg";